(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lev-fachbeirat"] && !Shopify.designMode) return;
  try {
    
  /* Rueck-Link: nur bei Ankunft von einer anderen levanura.de-Seite sichtbar.
     Beschriftung aus der Pfad-Zuordnung (data-map, eine Zeile je "pfad=Label";
     Pfad mit Schlussstrich = Praefix, sonst exakter Treffer, laengster Pfad gewinnt). */
  class LevBacklink extends HTMLElement {
    connectedCallback() {
      let ref = null;
      try {
        ref = document.referrer ? new URL(document.referrer) : null;
      } catch (e) {
        ref = null;
      }
      if (!ref || ref.origin !== window.location.origin || ref.pathname === window.location.pathname) return;

      const rows = (this.dataset.map || '')
        .split('\n')
        .map((l) => l.trim())
        .filter(Boolean)
        .map((l) => {
          const i = l.indexOf('=');
          return i > 0 ? [l.slice(0, i).trim(), l.slice(i + 1).trim()] : null;
        })
        .filter(Boolean);

      let best = null;
      for (const [p, label] of rows) {
        const hit = p.endsWith('/') && p.length > 1
          ? ref.pathname.startsWith(p) && ref.pathname.length > p.length
          : ref.pathname === p;
        if (hit && (!best || p.length > best[0].length)) best = [p, label];
      }

      const a = this.querySelector('a');
      const span = this.querySelector('.fb-back-label');
      if (!a || !span) return;
      a.href = ref.href;
      span.textContent = best ? best[1] : (this.dataset.fallback || 'Zurück');
      a.addEventListener('click', (e) => {
        if (window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
      this.hidden = false;
    }
  }
  if (!customElements.get('lev-backlink')) customElements.define('lev-backlink', LevBacklink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lev-home-produkte"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.__levPdWiggle) { return; }
    window.__levPdWiggle = true;

    function arm(slider) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (!e.isIntersecting) { continue; }
          io.unobserve(e.target);
          var el = e.target;
          if (el.scrollWidth > el.clientWidth + 8 && el.scrollLeft < 8) {
            el.classList.add('pd-wiggle');
          }
        }
      }, { threshold: 0.35 });
      io.observe(slider);
    }

    function init() {
      if (!('IntersectionObserver' in window)) { return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      var sliders = document.querySelectorAll('.pd-slider');
      for (var i = 0; i < sliders.length; i++) { arm(sliders[i]); }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lev-lp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.__levLphInit) { return; }
    window.__levLphInit = true;

    function init() {
      var root = document.querySelector('[data-lev-lph]');
      if (!root) { return; }
      var bar = root.querySelector('[data-lph-sticky]');
      var link = root.querySelector('[data-lph-sticky-link]');
      var card = link ? document.getElementById(link.getAttribute('href').slice(1)) : null;
      if (!bar || !link || !card || !('IntersectionObserver' in window)) { return; }

      var forms = document.querySelectorAll('[data-lev-vm]');
      var seen = new Set();
      var done = false;

      function signedUp() {
        var thanks = document.querySelectorAll('.lev-vm__danke');
        for (var i = 0; i < thanks.length; i++) { if (!thanks[i].hidden) { return true; } }
        return false;
      }

      function update() {
        if (!done && signedUp()) { done = true; }
        var pastHero = card.getBoundingClientRect().bottom < 0;
        var show = !done && pastHero && seen.size === 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        link.tabIndex = show ? 0 : -1;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { seen.add(e.target); } else { seen.delete(e.target); }
        });
        update();
      }, { rootMargin: '0px 0px -10% 0px' });
      for (var i = 0; i < forms.length; i++) { io.observe(forms[i]); }

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });

      document.addEventListener('submit', function () { window.setTimeout(update, 1500); }, true);

      link.addEventListener('click', function (ev) {
        ev.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var mail = card.querySelector('input[type=email]');
        if (mail) { window.setTimeout(function () { mail.focus({ preventScroll: true }); }, reduce ? 0 : 450); }
      });

      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lev-pdp-explainer"] && !Shopify.designMode) return;
  try {
    
  class LevExplainer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      const bind = () => {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        this.toggles = Array.from(this.querySelectorAll('[data-xpl-toggle]'));
        this.slides = Array.from(this.querySelectorAll('.xpl-slide'));
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-xpl-toggle]');
          if (!button || !this.contains(button)) return;
          this.select(Number(button.dataset.index));
        });
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            bind();
          }
        }, { rootMargin: '200px' });
        observer.observe(this);
      } else {
        bind();
      }
    }

    select(index) {
      this.toggles.forEach((button) => {
        const open = Number(button.dataset.index) === index;
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        const item = button.closest('.xpl-item');
        if (item) item.classList.toggle('is-open', open);
        const body = document.getElementById(button.getAttribute('aria-controls'));
        if (body) body.hidden = !open;
      });
      this.slides.forEach((slide) => {
        slide.hidden = Number(slide.dataset.index) !== index;
      });
    }
  }
  if (!customElements.get('lev-explainer')) {
    customElements.define('lev-explainer', LevExplainer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lev-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  class LevBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.planInput = this.querySelector('[data-selling-plan-input]');
      this.priceEl = this.querySelector('[data-price]');
      this.suffixEl = this.querySelector('[data-suffix]');
      this.radios = this.querySelectorAll('input[name="lev-format"]');
      this.radios.forEach((r) => r.addEventListener('change', () => this.sync(r)));
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }
    sync(radio) {
      if (radio.disabled) return;
      if (this.planInput) {
        if (radio.dataset.plan) {
          this.planInput.value = radio.dataset.plan;
          this.planInput.disabled = false;
        } else {
          this.planInput.value = '';
          this.planInput.disabled = true;
        }
      }
      if (this.priceEl && radio.dataset.price) this.priceEl.textContent = radio.dataset.price;
      if (this.suffixEl) this.suffixEl.textContent = radio.dataset.suffix || '';
    }
    onSubmit(e) {
      if (!window.fetch || !this.form) return;
      e.preventDefault();
      const btn = this.form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', '');
      const data = new FormData(this.form);
      if (!data.get('selling_plan')) data.delete('selling_plan');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams(data),
      })
        .then((r) => r.json())
        .then(() => {
          window.location.href = this.dataset.cartUrl || '/cart';
        })
        .catch(() => {
          if (btn) btn.removeAttribute('disabled');
          this.form.submit();
        });
    }
  }
  if (!customElements.get('lev-buy-box')) customElements.define('lev-buy-box', LevBuyBox);

  class LevStickyCta extends HTMLElement {
    connectedCallback() {
      const bar = this.querySelector('.sticky-cta');
      const target = document.getElementById(this.dataset.observe);
      if (!bar || !target || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) {
              bar.classList.remove('is-visible');
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.classList.add('is-visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          });
        },
        { rootMargin: '-120px 0px 0px 0px' }
      );
      io.observe(target);
    }
  }
  if (!customElements.get('lev-sticky-cta')) customElements.define('lev-sticky-cta', LevStickyCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
